/**
 * Route definitions and global providers.
 * All pages are eagerly loaded for instant navigation.
 */
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import About from "./pages/About";
import MusicWeLove from "./pages/MusicWeLove";
import Videos from "./pages/Videos";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/NotFound";
import DustParticles from "./components/DustParticles";
import ScrollToTop from "./components/ScrollToTop";
import SkipToContent from "./components/SkipToContent";

const AppContent = () => (
  <TooltipProvider>
    <Sonner />
    <DustParticles />
    <SkipToContent />
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/about" element={<About />} />
      <Route path="/music-we-love" element={<MusicWeLove />} />
      <Route path="/videos" element={<Videos />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </TooltipProvider>
);

export default AppContent;
